import React from 'react';
import { Link } from 'react-router-dom';
import { t } from '../i18n';
import { useContactUsage } from '@/hooks/usePlanCatalog';
import { formatContacts } from '@/lib/planLadder';

/**
 * Contact-cap banner (V46), shown across the app shell, Hub included: amber
 * from 90% of the plan's contact cap, red once over it (marketing to the
 * newest contacts is paused server-side). Always offers the upgrade. Silent on
 * any error: the banner must never break the shell.
 */
export const ContactCapBanner: React.FC = () => {
  const { data: usage } = useContactUsage();
  if (!usage || usage.state === 'ok') return null;
  const over = usage.state === 'over';

  return (
    <div
      role="status"
      data-testid="contact-cap-banner"
      className={
        over
          ? 'flex items-center justify-between border-b border-red-200 bg-red-50 px-4 py-2 text-sm text-red-800'
          : 'flex items-center justify-between border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-800'
      }
    >
      <span>
        {over
          ? t('billing.banner.over', { count: formatContacts(usage.count), cap: formatContacts(usage.cap) })
          : t('billing.banner.warning', { pct: Math.floor(usage.pctUsed), cap: formatContacts(usage.cap) })}
      </span>
      <Link
        to="/settings/billing"
        className={
          over
            ? 'rounded bg-red-600 px-3 py-1 text-xs font-medium text-white transition-colors hover:bg-red-700'
            : 'rounded bg-amber-600 px-3 py-1 text-xs font-medium text-white transition-colors hover:bg-amber-700'
        }
      >
        {t('billing.banner.upgrade')}
      </Link>
    </div>
  );
};
